<div class="form-group row mb-1 select-dropdown" #formGroupRef>
    <label *ngIf="label && !hideLabel"
           [attr.for]="label | monRemoveWhiteSpace"
           class="col-sm-8 col-form-label text-bold capitalize-first-letter pt-1 text-right">
        {{ label }}<span *ngIf="ngRequired">*</span>
    </label>
    <div [ngClass]="containerWidth">
        <angular-selector
            [(ngModel)]="value"
            [name]="'select-' + (label | monRemoveWhiteSpace)"
            [attr.data-test]="'select-' + (label | e2eAttributeEncoding)"
            [attr.id]="label | monRemoveWhiteSpace"
            [options]="options"
            [disabled]="disabled"
            [disableSearch]="disableSearch"
            [multiple]="multiple"
            [placeholder]="defaultOption"
            [required]="ngRequired"
            [removeButton]="removeButton"
            [labelAttr]="nameAttr"
            [valueAttr]="returnValue"
            [groupAttr]="group"
            [viewItemTemplate]="viewTemplate"
            [dropdownItemTemplate]="dropdownTemplate"
            [dropdownGroupTemplate]="groupTemplate"
            [class]="isFieldValid() ? '' : 'is-invalid'"
            (change)="onSelectorChange($event.newValue)"
            (blur)="onSelectorBlur()">
        </angular-selector>
        <span class="form-text text-muted">{{ helpTxt }}</span>
    </div>
</div>
